import { isBeautifulLinkBasedOnId } from 'owa-attachment-link-common';
import { isHTMLAnchorElement } from 'owa-cross-window-types';

export default function isReadonlyBeautifulLink(node: Node): boolean {
    if (isHTMLAnchorElement(node)) {
        const anchorElement = node as HTMLAnchorElement;
        if (isBeautifulLinkBasedOnId(anchorElement)) {
            const contentEditableValue: string = anchorElement.getAttribute('contenteditable');
            return !!contentEditableValue && contentEditableValue.toLowerCase() === 'false';
        }
    }

    return false;
}
